import { useState, useCallback } from "react";
import { toast } from "sonner";

/**
 * Hook for copying dynamic text to clipboard with toast feedback
 * and temporary "copied" state tracking.
 *
 * Unlike Chakra's useClipboard (which takes a static value),
 * this supports copying different values at different times.
 */
export function useCopyToClipboard() {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);

  const copy = useCallback(
    async (text: string, key?: string, successMessage = "Copied!") => {
      await navigator.clipboard.writeText(text);
      toast.success(successMessage);
      const k = key ?? text;
      setCopiedKey(k);
      setTimeout(
        () => setCopiedKey((prev) => (prev === k ? null : prev)),
        2000,
      );
    },
    [],
  );

  const hasCopied = useCallback(
    (key: string) => copiedKey === key,
    [copiedKey],
  );

  return { copy, hasCopied };
}
